import { render } from "./VLotInfoBase.vue?vue&type=template&id=2c4fdd46"
import script from "./VLotInfoBase.vue?vue&type=script&lang=js"
export * from "./VLotInfoBase.vue?vue&type=script&lang=js"

import "./VLotInfoBase.vue?vue&type=style&index=0&id=2c4fdd46&lang=scss"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__